export default __webpack_public_path__ + "static/media/bg-documents.2d405947.jpg";